module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "student-life-at-manara.3cd55fe1.jpg" + "?" + Date.now();